var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-pref" },
    [
      _c(
        "div",
        { staticClass: "aright mb-2" },
        [
          _c("CompassButton", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.edition,
                expression: "!edition"
              }
            ],
            attrs: {
              label: _vm.$t.__("common.actions.edit"),
              type: "secondary"
            },
            on: {
              click: function($event) {
                _vm.edition = true
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.edition,
                expression: "edition"
              }
            ],
            attrs: {
              label: _vm.buttonTitle,
              type: "primary",
              loading: _vm.loading
            },
            on: {
              click: function($event) {
                return _vm.submitPeriods()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.edition,
              expression: "!edition"
            }
          ],
          staticClass: "table with-vertical-line"
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Exercice")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Date de début")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Date de fin")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.years, function(year) {
              return _c("tr", { key: year.name }, [
                _c("td", [_vm._v(_vm._s(year.name))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.getLocalDate(year.period[0])))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.getLocalDate(year.period[1])))])
              ])
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.edition,
              expression: "edition"
            }
          ],
          staticClass: "table with-vertical-line"
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Exercice")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Date de début")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$l10n.__("Date de fin")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.years, function(year, index) {
              return _c("fiscal-year-line", {
                key: year.name,
                attrs: {
                  title: year.name,
                  startError: _vm.getError(index, "start"),
                  endError: _vm.getError(index, "end"),
                  showDelete: index == _vm.years.length - 1
                },
                on: { remove: _vm.delExercice },
                model: {
                  value: year.period,
                  callback: function($$v) {
                    _vm.$set(year, "period", $$v)
                  },
                  expression: "year.period"
                }
              })
            }),
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("CompassButton", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.edition,
            expression: "edition"
          }
        ],
        staticClass: "mr-2 mt-2",
        attrs: {
          label: _vm.$t.__("preferences.FiscalYear.add_fiscal_year"),
          type: "tertiary"
        },
        on: {
          click: function($event) {
            return _vm.addExercice()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }